import Vue from 'vue'
import Router from 'vue-router'

// Components
import HomeView from '@/components/HomeView'
import Begin from '@/components/Begin'
import Plan from '@/components/Plan'
import Practice from '@/components/Practice'
// import DetailView from '@/components/DetailView'
// import PostView from '@/components/PostView'
import IntervalView from '@/components/IntervalView'
import MetronomeView from '@/components/MetronomeView'
import PlayerView from '@/components/PlayerView'
import OnboardingView from '@/components/onboarding/OnboardingView'
import VideoView from '@/components/VideoView'
import NotationView from '@/components/NotationView'
import DesignSystemView from '@/components/DesignSystemView'

// Auth0 tutorial
import PrivateBattles from '@/components/privateBattles'
import PublicBattles from '@/components/publicBattles'

import Login from '@/components/Login'
import Payment from '@/components/Payment'
import Callback from '@/components/callback'

// Auth helpers
import { requireAuth } from '../utils/auth'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [

    {
      path: '/',
      name: 'begin',
      // beforeEnter: requireAuth,
      component: Begin
    },
    {
      path: '/plan',
      name: 'plan',
      // beforeEnter: requireAuth,
      component: Plan
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/practice',
      name: 'practice',
      component: Practice
    },
    {
      path: '/home',
      name: 'home',
      // beforeEnter: requireAuth,
      component: HomeView
    },
    /* JUNK old firebase POC
    {
      path: '/detail/:id',
      name: 'detail',
      component: DetailView
    },
    {
      path: '/post',
      name: 'post',
      component: PostView
    },
    */
    {
      path: '/metronome',
      name: 'metronome',
      component: MetronomeView
    },
    {
      path: '/onboard',
      name: 'onboard',
      // beforeEnter: requireAuth,
      component: OnboardingView
    },
    {
      path: '/interval',
      name: 'interval',
      component: IntervalView
    },
    {
      path: '/player',
      name: 'player',
      component: PlayerView
    },
    {
      path: '/video',
      name: 'video',
      component: VideoView
    },
    {
      path: '/notation',
      name: 'notation',
      component: NotationView
    },
    {
      path: '/design',
      name: 'design',
      component: DesignSystemView
    },
    {
      path: '/public-battles',
      name: 'PublicBattles',
      component: PublicBattles
    },
    {
      path: '/payment',
      // beforeEnter: requireAuth,
      name: 'Payment',
      component: Payment
    },
    {
      path: '/private-battles',
      name: 'PrivateBattles',
      beforeEnter: requireAuth,
      component: PrivateBattles
    },
    {
      path: '/callback',
      component: Callback
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js